"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadingOverlay = exports.LoadingContainer = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactLoadingOverlay = _interopRequireDefault(require("react-loading-overlay"));

var _components = require("../addressAutocomplete/components");

var LoadingContainer = _styledComponents["default"].div.withConfig({
  displayName: "components__LoadingContainer",
  componentId: "sc-1t28djc-0"
})(["display:flex;justify-content:center;"]);

exports.LoadingContainer = LoadingContainer;
var StyledLoader = (0, _styledComponents["default"])(_reactLoadingOverlay["default"]).withConfig({
  displayName: "components__StyledLoader",
  componentId: "sc-1t28djc-1"
})([".fileUpload_overlay{border-radius:3px;}&.fileUpload_wrapper--active{overflow:hidden;}"]);

var UploadingOverlay = function UploadingOverlay(_ref) {
  var active = _ref.active,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(StyledLoader, {
    active: active,
    classNamePrefix: "fileUpload_",
    spinner: /*#__PURE__*/_react["default"].createElement(LoadingContainer, null, /*#__PURE__*/_react["default"].createElement(_components.Loader, null), ' ', /*#__PURE__*/_react["default"].createElement("span", {
      style: {
        paddingTop: '18px',
        paddingLeft: '5px'
      }
    }, "Uploading files"))
  }, children);
};

exports.UploadingOverlay = UploadingOverlay;